import { render, staticRenderFns } from "./needAcontract.vue?vue&type=template&id=64c79055&scoped=true"
import script from "./needAcontract.vue?vue&type=script&lang=js"
export * from "./needAcontract.vue?vue&type=script&lang=js"
import style0 from "./needAcontract.vue?vue&type=style&index=0&id=64c79055&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c79055",
  null
  
)

export default component.exports